export default __webpack_public_path__ + "static/media/logo-white-bg.9df53dda.png";